var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C6 1 6 1 6.09765625 4.81640625 C6.09098089 6.39846682 6.07901875 7.98051159 6.0625 9.5625 C6.05798828 10.36880859 6.05347656 11.17511719 6.04882812 12.00585938 C6.03700518 14.00393756 6.01906914 16.00197783 6 18 C4.02 18 2.04 18 0 18 C0 12.06 0 6.12 0 0 Z ",
    fill: "#0B51C5",
    transform: "translate(12,5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 5.94 3 11.88 3 18 C10.59 18 18.18 18 26 18 C26 18.66 26 19.32 26 20 C17.42 20 8.84 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#0B51C5",
    transform: "translate(1,7)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C6 1 6 1 6.09765625 4.37890625 C6.09098369 5.77347077 6.07902532 7.16801743 6.0625 8.5625 C6.05798828 9.27341797 6.05347656 9.98433594 6.04882812 10.71679688 C6.03700864 12.47790013 6.01907263 14.23896036 6 16 C4.02 16 2.04 16 0 16 C0 10.72 0 5.44 0 0 Z ",
    fill: "#0B51C5",
    transform: "translate(19,7)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C6 1 6 1 6.09765625 3.50390625 C6.08605469 4.51324219 6.07445312 5.52257812 6.0625 6.5625 C6.05347656 7.57441406 6.04445313 8.58632813 6.03515625 9.62890625 C6.02355469 10.41136719 6.01195312 11.19382812 6 12 C4.02 12 2.04 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#0B51C5",
    transform: "translate(5,11)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.2a3e58abfcb41b237429e84121a37b61.svg";
export { ForwardRef as ReactComponent };